/**
 * The session ended — the server no longer knows who is asking.
 *
 * It is its own type so the difference survives the trip to a screen. Everything downstream of a
 * failed discovery fails too, with messages about missing links; only here is the actual cause
 * known, and a teacher must be told "reconnectez-vous", never "root:subjects".
 */
export class SessionExpiredError extends Error {
  constructor() {
    super("SESSION_EXPIRED");
    this.name = "SessionExpiredError";
  }
}

/** True for the original failure and for every missing-link error that follows from it. */
export const isSessionExpired = (error: unknown): boolean => {
  if (error instanceof SessionExpiredError) return true;
  const message = error instanceof Error ? error.message : String(error ?? "");
  return /SESSION_EXPIRED/.test(message) || /No HATEOAS link found for root:/.test(message);
};
